<template>
  <div>
    <BuscaAvancada v-model="relatorio_oportunidades.filtros" />
  </div>
</template>

<script>
import BuscaAvancada from "@/modules/oportunidades/Components/BuscaAvancada.vue";
import { mapState } from "vuex";

export default {
  components: { BuscaAvancada },
  data: () => ({}),
  computed: {
    ...mapState("relatorios", ["relatorio_oportunidades"]),
  },
  created() {},
};
</script>
